/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_StateInputs */

const cs_enum_state = /** @type {(inputs: Enum_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stát`)
};

const en_enum_state = /** @type {(inputs: Enum_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`State`)
};

/**
* | output |
* | --- |
* | "State" |
*
* @param {Enum_StateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_state = /** @type {((inputs?: Enum_StateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_StateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_state(inputs)
	return cs_enum_state(inputs)
});